import { toaster } from 'components'
import { createContext, useEffect, useState } from 'react'
import { generatePath, useNavigate, useParams, useSearchParams } from 'react-router'
import { GetPublicEventDataProps, IPublicEvent } from 'types'
import { getPublicEventData } from 'utils'
import { RoutePath } from '../utils/routing'

export const EventContext = createContext<IPublicEvent | undefined>({} as any)

export function EventProvider({ children }: { children: any }) {
  const eventId = useParams().id
  const [searchParams] = useSearchParams()
  const momentId = Number.parseInt(searchParams.get('momentId')?.trim() || '')
  const [eventInfo, setEventInfo] = useState<IPublicEvent>()
  const navigate = useNavigate()

  useEffect(() => {
    if (!eventId) return

    const fetchEventData = async () => {
      try {
        const eventParams: GetPublicEventDataProps = momentId ? { eventId, momentId } : { eventId }
        const { data } = await getPublicEventData(eventParams)
        setEventInfo(data)
        if (Object.keys(data).length === 0) {
          navigate(generatePath(RoutePath.Home))
        }
      } catch (error) {
        toaster.create({ description: `Failed to fetch event data: ${error}`, type: 'error' })
        navigate(generatePath(RoutePath.Home))
      }
    }

    fetchEventData()
  }, [eventId])

  return <EventContext.Provider value={eventInfo}>{children}</EventContext.Provider>
}
